const axios = require('axios').default;

export const getBranchByAllDeliveryLine = (props = {token:"", supplierId:0}) => {
    return axios.get(`${process.env.REACT_APP_API_URL}/api/getBranchByAllDeliveryLine/`, 
    {
        params:{
            id:props.supplierId
        },
        headers: {
          'Authorization': `Basic ${props.token}`,
        }
    })
}